export const FavouriteButton = {
  bindings: {
    isFavourite: '<',
  },

  template: `
    <button class="favourite-btn pointer" type="button">
      <i class="fa text-green p-3 pointer"
        ng-class="{
          'fa-heart': $ctrl.isFavourite,
          'fa-heart-o': !$ctrl.isFavourite
        }">
      </i>
    </button>
  `,
};



// WEBPACK FOOTER //
// ./src/components/Favourite/FavouriteButton.js